import React from "react";
import { Link } from "react-router-dom";
import SiteShell from "../../components/layout/SiteShell";
import ContentPageLayout from "../../components/content/ContentPageLayout";
import SEO from "../../components/seo/SEO";
import ConversionCtas from "../../components/content/ConversionCtas";

export default function SeaMossWeightManagementPage() {
  const path = "/learn/sea-moss-for-weight-management";
  return (
    <SiteShell theme="dark">
      <SEO
        title="Sea moss and weight management | Honest MossMatrix guide"
        description="Sea moss is not a magic weight-loss product. How MossMatrix gel may fit a balanced routine: low-calorie stir-ins in drinks and oats you make at home, alongside hydration, meals, movement, and sleep."
        path={path}
      />
      <ContentPageLayout
        eyebrow="Learn"
        title="Sea Moss & Weight Management"
        subtitle="Not a shortcut, just a simple addition to a balanced routine. Sea moss is not a magic weight-loss product; some people enjoy how it thickens shakes, smoothies, and oats they make at home without heavy creams or syrups."
      >
        <div className="rounded-2xl border border-forest/15 bg-forest text-cream p-6 md:p-8 mb-12 max-w-3xl">
          <h2 className="font-serif text-xl text-cream">Sea moss is not a magic weight-loss product</h2>
          <p className="mt-3 text-sm leading-relaxed text-cream/90">
            If a brand promises guaranteed weight loss, walk away. MossMatrix is here for honest gel and calm copy, not fear-based marketing.
          </p>
        </div>

        <section className="rounded-3xl border border-cream bg-white p-8 mb-10 max-w-3xl">
          <h2 className="font-serif text-2xl text-forest">Why people stir it into smoothies and oats at home</h2>
          <p className="mt-3 text-sm text-botanical/85 leading-relaxed">
            Sea moss gel is commonly used because it is low-effort to stir in, can feel satisfying in the mouth, and carries minerals people like
            tracking alongside whole foods. It can sit alongside habits you already chose. It does not replace them.
          </p>
        </section>

        <section className="rounded-3xl border border-cream bg-offwhite p-8 mb-10 max-w-3xl">
          <h2 className="font-serif text-2xl text-forest">Low-effort routine ideas</h2>
          <ul className="mt-4 space-y-2 text-sm text-botanical/85">
            <li>• Swap heavy cream in pasta sauce for a spoonful of gel + splash of water.</li>
            <li>• Thicken a shake or smoothie you blend at home so fibre and protein can feel a little more satisfying in the mouth.</li>
            <li>• Stir into oats with cinnamon instead of reaching for extra sugar.</li>
          </ul>
        </section>

        <section className="rounded-3xl border border-cream bg-white p-8 mb-12 max-w-3xl">
          <h2 className="font-serif text-2xl text-forest">Pair with hydration, balanced meals, movement, and sleep</h2>
          <p className="mt-3 text-sm text-botanical/85 leading-relaxed">
            Gel is a small piece of the puzzle. Hydration, balanced meals, joyful movement, and rest still do the heavy lifting, and a clinician or dietitian is the right person for personalised plans.
          </p>
        </section>

        <div className="text-center rounded-3xl border border-gold/40 bg-cream/40 px-6 py-10 max-w-xl mx-auto">
          <p className="text-sm text-botanical/80 mb-5">Ready to play with lighter blends?</p>
          <Link
            to="/shop"
            className="inline-flex rounded-full bg-forest text-cream px-8 py-3.5 text-sm font-medium hover:bg-botanical transition"
          >
            Build a lighter daily blend
          </Link>
        </div>

        <ConversionCtas />

        <p className="text-sm text-botanical/80 text-center mt-10">
          <Link to="/learn/how-to-use-sea-moss-gel" className="underline hover:text-forest">
            How to use gel
          </Link>
          {" · "}
          <Link to="/learn" className="underline hover:text-forest">
            Learn hub
          </Link>
          {" · "}
          <Link to="/shop" className="underline hover:text-forest">
            Shop
          </Link>
          {" · "}
          <Link to="/faq" className="underline hover:text-forest">
            FAQ
          </Link>
        </p>
      </ContentPageLayout>
    </SiteShell>
  );
}
